__turbopack_context__.v({
  "pageContainer": "Page-module__0pKfCG__pageContainer",
});
